import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCreateCategory } from '../../api/categories';
import CommonModalLayout from '../Layouts/CommonModalLayout';
import { buttonStyles, inputStyles } from '../../styles/commonStyles';
import ErrorMessage from '../Common/ErrorMessage';

const AddCategoryModal = ({ isOpen, onClose, onSuccess, groupName, groupId }) => {
    const { t } = useTranslation();
    const [categoryName, setCategoryName] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const createCategoryMutation = useCreateCategory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!categoryName.trim()) {
            setError('Название категории не может быть пустым');
            return;
        }

        setIsLoading(true);
        setError('');

        try {
            await createCategoryMutation.mutateAsync({
                name: categoryName.trim(),
                group_id: groupId,
                userId: null // Будет взят из хука
            });
            
            setCategoryName('');
            onSuccess?.();
            onClose();
        } catch (error) {
            console.error('Ошибка создания категории:', error);
            setError(error.message || 'Ошибка создания категории');
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        setCategoryName('');
        setError('');
        onClose();
    };

    return (
        <>
            {/* Кастомный оверлей с высоким z-index */}
            {isOpen && (
                <div 
                    className="fixed bg-black/60 dark:bg-black/60 backdrop-blur-sm z-[10005] border-0 border-none outline-none"
                    style={{ 
                        border: 'none', 
                        outline: 'none',
                        top: '-1px',
                        right: '-1px', 
                        bottom: '-1px',
                        left: '-1px'
                    }}
                    onClick={() => {}} // Не закрываем по клику на оверлей
                />
            )}
            <CommonModalLayout
                isOpen={isOpen}
                onClose={handleClose}
                title="Новая категория"
                customStyles="fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 w-[90vw] max-w-md z-[10006] border border-gray-300 dark:border-gray-700"
                closeOnOverlayClick={false}
                hideOverlay={true}
            >
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <input
                        id="categoryName"
                        type="text"
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                        className={inputStyles}
                        placeholder="Введите название категории..."
                        autoFocus
                        maxLength={100}
                    />
                </div>

                <ErrorMessage message={error} />

                {/* Подсказка о группе */}
                <div className="text-sm text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-700 p-3 rounded border">
                    Категория будет добавлена в группу "{groupName}"
                </div>

                <div className="flex justify-end space-x-2 pt-4">
                    <button
                        type="button"
                        onClick={handleClose}
                        className={buttonStyles}
                        disabled={isLoading}
                    >
                        Отмена
                    </button>
                    <button
                        type="submit"
                        className={buttonStyles}
                        disabled={isLoading || !categoryName.trim()}
                    >
                        {isLoading ? 'Создание...' : 'Создать категорию'}
                    </button>
                </div>
            </form>
            </CommonModalLayout>
        </>
    );
};

export default AddCategoryModal;
